import { getCalendarDateStringInTimeZone } from 'lib/datetime/dateUtils'

const AUSTRALIA_SYDNEY_TIME_ZONE = 'Australia/Sydney'
const STATUS_MATCH_NAV_VISIBLE_UNTIL_SYDNEY_DATE = '2026-09-30'

export interface SocieteStatusMatchNavConfig {
  path: string
  slug: string
  /** Inclusive last calendar day the link should show, in Australia/Sydney. */
  visibleUntilSydneyDate: string
}

function septemberCampaign(slug: string): SocieteStatusMatchNavConfig {
  return {
    slug,
    path: `/societe/${slug}`,
    visibleUntilSydneyDate: STATUS_MATCH_NAV_VISIBLE_UNTIL_SYDNEY_DATE,
  }
}

export const STATUS_MATCH_NAV_CONFIG_BY_REGION: Record<string, SocieteStatusMatchNavConfig> = {
  AU: septemberCampaign('status-match-au-september-2026'),
  FR: septemberCampaign('status-match-fr-september-2026'),
  DE: septemberCampaign('status-match-de-september-2026'),
}

export function isSocieteStatusMatchNavVisible(
  config: SocieteStatusMatchNavConfig | undefined,
  activeCampaigns: Array<{ config: { slug: string } }>,
  now: Date = new Date(),
): boolean {
  if (!config) return false
  const hasMatchingCampaign = activeCampaigns.some((campaign) => campaign.config.slug === config.slug)
  if (!hasMatchingCampaign) return false
  return getCalendarDateStringInTimeZone(now, AUSTRALIA_SYDNEY_TIME_ZONE) <= config.visibleUntilSydneyDate
}
